"use client"

import React, { useState, useEffect, Fragment } from 'react'
import { Tabs, Card } from 'antd'
import {
  MobileProvider,
  EsimInfo,
  Phones,
  Pricing,
  UserGuide,
  FAQ,
  CommonErrors
} from '@/components/esim'
import { useIsDesktop } from '@/hooks/app/useIsDesktop'
import { useTranslation } from 'react-i18next'
import MKTScript from '../MKTScript'
import Title from '../common/Typography/Title'


export default function Esim() {
  const isDesktop = useIsDesktop()
  const [activeTab, setActiveTab] = useState('1')
  const [isMounted, setIsMounted] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const handleTabChange = (key: string) => {
    setActiveTab(key)
    // Scroll to top when changing tabs on mobile
    if (!isDesktop) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  const tabItems = [
    {
      key: '1',
      label: t("esim.esim_info_title"),
      children: <EsimInfo />
    },
    {
      key: '2',
      label: t("esim.device_support_title"),
      children: <Phones />
    },
    {
      key: '3',
      label: t("esim.rates_title"),
      children: <Pricing />
    },
    {
      key: '4',
      label: t("esim.setting_guide_title"),
      children: <UserGuide />
    },
    {
      key: '5',
      label: t("esim.faq_title"),
      children: <FAQ />
    },
    {
      key: '6',
      label: t("esim.error_handling_title"),
      children: <CommonErrors />
    }
  ]

  const renderTabs = () => (
    <Tabs
      defaultActiveKey="1"
      activeKey={activeTab}
      onChange={handleTabChange}
      tabPosition={isDesktop ? 'left' : 'top'}
      className="esim-tabs"
      style={{ width: '100%' }}
      items={tabItems}
      size={!isDesktop ? 'small' : 'middle'}
      centered={false}
      moreIcon={<span style={{ fontSize: '1.6rem' }}>...</span>}
    />
  )

  // Only render content when component is mounted to prevent hydration issues
  if (!isMounted) {
    return (
      <MobileProvider>
        <div className="esim" style={{ display: 'none' }}>
          <div className="esim__content">
            <div className="esim__tabs-container">
              <Card loading style={{ width: '100%', minHeight: '50vh' }} />
              <div style={{ display: 'none'  }}>
              {tabItems.map(({ children, label, key }) => {
                return (
                  <Fragment key={key}>
                    <Title>
                      {label}
                    </Title>
                    {children}
                  </Fragment> 
                )
              })}
              </div>
            </div>
          </div>
        </div>
      </MobileProvider>
    )
  }

  return (
    <MobileProvider>
      <MKTScript />
      <div className="esim">
        <div className="esim__content">
          <h1 style={{ fontSize: '2.4rem', marginBottom: '1rem', fontWeight: 600 }}>
            {t("esim.title")}
          </h1>
          <div className="esim__tabs-container">
            {renderTabs()}
          </div>
        </div>
      </div>
    </MobileProvider>
  )
}